import { render, staticRenderFns } from "./ed-image-created.vue?vue&type=template&id=ccc8966a&scoped=true&"
import script from "./ed-image-created.ts?vue&type=script&lang=ts&"
export * from "./ed-image-created.ts?vue&type=script&lang=ts&"
import style0 from "./ed-image-created.scss?vue&type=style&index=0&id=ccc8966a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc8966a",
  null
  
)

export default component.exports